import { waitForFetch } from '@ember/test-waiters';

export function wrappedFetch(...args: Parameters<typeof fetch>): Promise<Response> {
  return waitForFetch(fetch(...args));
}
